import { useQuery } from '@tanstack/react-query';
import Spinner from 'components/Spinner';
import React from 'react'
import HTTPClient from 'services/HTTPClient';

type Props = {}

const useIframe = () => {
    const url = `/api/tenant/metabase`
    let query = {
        dashboard_name: "stats",
    }
    return useQuery(['iframe'], async () => {
        let response = await HTTPClient.get().getJSONResult(url, query)
        return response.url
    });
};

export default function StatsPage({ }: Props) {
    const { data: url, isLoading, error } = useIframe();

    if (isLoading) {
        return <div className="center my-5">
            <Spinner />
        </div>
    }

    return (
        <iframe
            title='metabase'
            src={url}
            frameBorder="0"
            width="100%"
            height="100%"
        ></iframe>
    )
}